import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { FilterType } from '../../enum/filter-type.enum';
import {
  IFilterInput,
  IFilterValue,
  IOption,
} from '../../models/filter-input.interface';

@Component({
  selector: 'rr-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class RRFilterComponent implements OnInit {
  @ViewChild('optionView') optionView;
  @ViewChild('filterButton') filterButton;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (
      !this.optionView.nativeElement.contains(event.target) &&
      !this.filterButton.nativeElement.contains(event.target)
    ) {
      if (event.target.classList.contains('check-icon')) {
        return;
      }
      this.showOptions = false;
    }
  }

  @Input() settings: IFilterInput;
  @Output() selectedItems: EventEmitter<IFilterValue[]> = new EventEmitter();
  public selectedItemsList: IOption[];
  public showOptions: boolean;
  public filterName: string;

  constructor() {}

  ngOnInit(): void {
    this.selectedItemsList = this.settings.options.filter((o) => o.selected);
  }
  public toggleOptionView() {
    this.showOptions = !this.showOptions;
  }
  public optionClicked(option: any) {
    if (this.settings.type === FilterType.SINGLE_SELECT) {
      this.settings.options.map((o) => (o.selected = false));
    }
    option.selected = !option.selected;
    this.selectedItemsList = this.settings.options.filter((o) => o.selected);
    this.selectedItems.emit([
      ...this.selectedItemsList.map((o) => {
        return o.value;
      }),
    ]);
  }
  public filterValueChanged(value: any) {
    if (value === '') {
      this.settings.options.map((item) => {
        item.hide = false;
      });
      return;
    }
    this.settings.options.map((item) => {
      if (!item.value.value.toLowerCase().includes(value.toLowerCase())) {
        item.hide = true;
      } else {
        item.hide = false;
      }
    });
  }
}
